import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { ContentWrapper, StyledFlexRow, Title, TitleWrapper } from './Reviews';
import { DsiRelatedProduct as RelatedProduct } from './RelatedProduct';
import { getRelatedProductInfo } from '../../../utilities/selectors';
import { StyledTitle } from './Description';
import { IconType, DsiSvgIcon as SvgIcon } from '../../Dsi/General/SvgIcon';

interface Props {
  products: any;
  isOpen: boolean;
  apiUrl: string;
  title?: string;
  conditionTextMapping?: any;
}

function Related(props) {
  const { isOpen, products, apiUrl, title, conditionTextMapping } = props;

  if (products && products.total === 0) {
    return <></>;
  }

  const renderRelatedProduct = (key, product) => {
    const info = getRelatedProductInfo(product, apiUrl);
    const {
      name,
      picture,
      price,
      url,
      description,
      currency,
      onStockCount,
      availid,
      availability,
      isNew,
      condition,
      isWaiting,
    } = info;

    return (
      <ItemWrapper key={key}>
        <RelatedProduct
          name={name}
          description={description}
          price={price}
          currency={currency}
          picture={picture}
          url={url}
          availid={availid}
          availability={availability}
          onStockCount={onStockCount}
          isNew={isNew}
          condition={condition}
          conditionTextMapping={conditionTextMapping}
          isWaiting={isWaiting}
        />
      </ItemWrapper>
    );
  };

  return (
    <>
      <StyledFlexRowNew isOpen={isOpen}>
        {products && products.total > 0 && (
          <>
            {title && (
              <TitleContainer>
                <IconContainer>
                  <SvgIcon icon={IconType.related} />
                </IconContainer>
                <StyledTitleNew>{title}</StyledTitleNew>
              </TitleContainer>
            )}
            <StyledContentWrapper>
              {products &&
                products.total > 0 &&
                products.products.map((p: any, key) =>
                  renderRelatedProduct(key, p),
                )}
            </StyledContentWrapper>
          </>
        )}
      </StyledFlexRowNew>
    </>
  );
}

const StyledFlexRowNew = styled(StyledFlexRow)``;

const StyledTitleNew = styled(StyledTitle)`
  margin-bottom: 0;
`;

const IconContainer = styled.div`
  margin-right: ${rem(16)};
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(32)};
`;

const ItemWrapper = styled.div`
  width: 32%;
  margin-right: ${rem(16)};
  margin-bottom: ${rem(16)};
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  ${({ theme }) => theme.mediab.l925`
      &:nth-child(3n + 3) {
        margin-right: ${rem(16)};
      }
      &:nth-child(2n + 2) {
        margin-right: 0;
      }
    width: 48%;
  `}
  ${({ theme }) => theme.mediab.m600`
      width: 100%;
      margin-right: 0;
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
  `}
`;

const StyledContentWrapper = styled(ContentWrapper)`
  ${({ theme }) => theme.mediab.m810`
        flex-direction: row;
    `}
`;

export { Related as DsiRelated };
